import { createFileRoute, retainSearchParams } from "@tanstack/react-router"
import { fallback } from "@tanstack/zod-adapter"
import { z } from "zod"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { PaymentTermSortField, SortingOrder } from "@/graphql/codegen/graphql"
import { PaymentTermsContainer } from "@/screens/Accounting/subfeatures/PaymentTerms"

const SearchParamsValidator = z.object({
  field: fallback(z.nativeEnum(PaymentTermSortField), PaymentTermSortField.Name),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Asc),
})

export const Route = createFileRoute("/app/admin/accounting/_layout/payment-terms")({
  validateSearch: SearchParamsValidator,
  search: {
    middlewares: [retainSearchParams(["field", "order"])],
  },
  component: () => (
    <PermissionContentWrapper
      permissions={[
        PermissionActionType.ACCOUNTING_VIEW,
        PermissionActionType.ACCOUNTING_MANAGER,
        PermissionActionType.ACCOUNTING_MAINTENANCE,
      ]}
    >
      <PaymentTermsContainer />
    </PermissionContentWrapper>
  ),
})
